
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 16 13\" id=\"fullscreen\" ><title>Asset 22</title><g data-name=\"Layer 2\"><path d=\"M0 7h9v6H0z\"/><path d=\"M11 13v-1.5h3.75V1.25H1.25V5H0V0h16v13h-5z\"/></g></symbol>";
module.exports = sprite.add(image, "fullscreen");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/fullscreen.svg
// module id = 655
// module chunks = 1474